import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { wifiCallingColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getWifiCalling } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "plan_id",
  "plan",
  "trial_count",
  "zipcode",
  "last_updated",
];

const WifiCallingBatch = () => (
  <BatchDetail
    title="Wifi Calling"
    apiGet={__getWifiCalling}
    client={CLIENTS.ultra}
    columnsFactory={wifiCallingColumns}
    copyKeys={COPY_KEYS}
    exportAction="wifi_calling"
    retryOperation="wifi_calling"
    showTerminate
    getRowPath={(row) => `/ultra/wifi_calling/${row.id}`}
  />
);

export default WifiCallingBatch;
